import styled from 'styled-components';
import TabLink from '~/client/shared/styles/TabLink';

const TabLinkStyled = styled(TabLink)`
  && {
    width: 50%;
    text-align: center;
  }
`;

type Props = {
  type: RtpType;
  rtp: RtpType;
  handleClick: (rtp: RtpType) => void;
};

const LiveRtpTabLink: FC<Props> = ({ type, rtp, handleClick, children }) => {
  const active = rtp === type;
  return (
    <TabLinkStyled
      className={active ? 'active' : ''}
      onClick={() => handleClick(type)}
      as={'a'}
    >
      {children}
    </TabLinkStyled>
  );
};

export default LiveRtpTabLink;
